import { getHandleResponse } from "helpers/getHandleResponse";
import { getAuthHeader } from "helpers/getAuthHeader";

const API_BASE_URL = process.env.REACT_APP_URL;

const makeRequest = async (endpoint, method, data = null) => {
    const requestOptions = {
        method,
        headers: getAuthHeader(),
    };

    if (data) {
        requestOptions.body = JSON.stringify(data);
    }

    try {
        const response = await fetch(`${API_BASE_URL}${endpoint}`, requestOptions);
        const result = await getHandleResponse(response);
        return { error: false, data: result };
    } catch (error) {
        return { error: true, data: error.message };
    }
};

const buildQueryString = (params) => {
    const filteredParams = Object.entries(params)
        .filter(([_, value]) => value !== null && value !== undefined && value !== '')
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

    return new URLSearchParams(filteredParams).toString();
};

const providerService = {
    // Obtener todos los proveedores
    getProviders: (params = {}) => {
        const queryString = buildQueryString(params);
        return makeRequest(`/api/providers${queryString ? `?${queryString}` : ''}`, "GET");
    },

    // Obtener ranking de proveedores
    getProviderRanking: (limit = 10) => {
        return makeRequest(`/api/providers/ranking?limit=${limit}`, "GET");
    },

    // Obtener proveedor por ID
    getProviderById: (id) => makeRequest(`/api/providers/${id}`, "GET"),

    // Crear proveedor (solo admin)
    createProvider: (data) => makeRequest("/api/providers", "POST", data),

    // Actualizar proveedor (solo admin)
    updateProvider: (id, data) => makeRequest(`/api/providers/${id}`, "PUT", data),

    // Eliminar proveedor (solo admin)
    deleteProvider: (id) => makeRequest(`/api/providers/${id}`, "DELETE"),
};

export default providerService;